import styles from './ProgressBar.module.scss'

interface ProgressBarProps {
  percent: number
  className?: string
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ percent, className }) => {
  const normalizedPercent = Math.min(Math.max(percent, 0), 100)

  return (
    <div className={`${styles.progressBar} ${className || ''}`}>
      <div
        className={styles.progressFill}
        style={{ width: `${normalizedPercent}%` }}
      />
    </div>
  )
} 